import { SortByWords } from "@/constants/category";
import useOnClickOutside from "@/hooks/useOnClickOutside";
import useFilterData from "@/hooks/useSearchParams";
import React, { useRef, useState } from "react";

const Sorting = ({ t }) => {
    const { getFilterObj, setFilterQueryHandler } = useFilterData();
    const sortMenuRef = useRef();
    const [show, setShow] = useState(false);

    const selectedSortCode = getFilterObj?.sort || SortByWords[0]?.shortCode;
    const selectedSort =
        SortByWords.find((item) => item.shortCode === selectedSortCode) ||
        SortByWords[0];

    useOnClickOutside([sortMenuRef], () => show && setShow(false));

    const handleSortChange = (item) => {
        setFilterQueryHandler({ sort: item.shortCode, p: null });
        setShow(false);
    };

    return (
        <div className="flex gap-2 items-center">
            <span>{t("SortBy")}</span>
            <div ref={sortMenuRef} className="relative">
                <div
                    onClick={() => setShow((prev) => !prev)}
                    className="flex items-center overflow-hidden hover:bg-gray-50 rounded-md border bg-white min-w-36 cursor-pointer"
                >
                    <span className="px-4 flex-grow py-2 text-sm/none text-gray-600 hover:text-gray-700">
                        {t(selectedSort?.text)}
                    </span>
                    <button className="h-full p-2 text-gray-600 hover:text-gray-700">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="size-4"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                        >
                            <path
                                fillRule="evenodd"
                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                clipRule="evenodd"
                            />
                        </svg>
                    </button>
                </div>

                {show && (
                    <div
                        className="absolute end-0 z-[999] mt-2 min-w-36 rounded-md border border-gray-100 bg-white shadow-lg"
                        role="menu"
                    >
                        <div className="p-2">
                            {SortByWords?.map((item) => (
                                <button
                                    onClick={() => handleSortChange(item)}
                                    key={item?.shortCode}
                                    className={`block w-full text-start rounded-lg px-4 py-2 hover:text-red text-sm text-gray-500 hover:bg-gray-50 ${
                                        item?.shortCode ===
                                        selectedSort?.shortCode
                                            ? "text-red"
                                            : ""
                                    }`}
                                    role="menuitem"
                                >
                                    {t(item?.text)}
                                </button>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default React.memo(Sorting);
